<div class="ecb-admin-card p-4">
  <h1 class="ecb-section-title">My profile</h1>
  <div class="row g-3">
    <div class="col-md-6"><label>First name</label><input class="ecb-form-control" [(ngModel)]="model.firstName"></div>
    <div class="col-md-6"><label>Last name</label><input class="ecb-form-control" [(ngModel)]="model.lastName"></div>
    <div class="col-md-6"><label>Email</label><input class="ecb-form-control" [(ngModel)]="model.email" disabled></div>
    <div class="col-md-6"><label>Mobile</label><input class="ecb-form-control" [(ngModel)]="model.mobileNo"></div>
    <div class="col-12"><label>Company</label><input class="ecb-form-control" [(ngModel)]="model.companyName"></div>
  </div>
  <button class="ecb-btn-primary mt-4" (click)="save()">Save Profile</button>
</div>